<template>
  <InstalarPantalla :open="open" titulo="Instalar POS" icono="mdi-point-of-sale"
    subtitulo="Elige la sucursal y la caja que va a usar este equipo.">
    <template #avisos>
      <div v-if="backup" class="instalar-aviso instalar-aviso--copia mb-4">
        <strong>Se ha detectado una copia del sistema, ¿Desea restaurarla?</strong>
        <v-btn small outlined color="success" class="mt-2" @click="restore()" :loading="loading"
          :disabled="loading">Restaurar Backup</v-btn>
      </div>
    </template>

    <div :key="key">
      <ng-select-options v-model="item.bus_subsidiary_id" label="Sucursal" :rules="{ required: true }"
        :items="subsidiaries" @input="changeSubsidiary" :filled="false" :dense="false"></ng-select-options>
      <ng-select-options v-model="item.bill_cash_register_id" label="Caja" :rules="{ required: true }"
        :items="cashResgisters" :filled="false" :dense="false"></ng-select-options>
      <!-- Una caja, un equipo: con este nombre se reconoce el equipo en el ERP
           (Configuración › Cajas) y en el aviso de otro equipo que intente usar la caja. -->
      <v-text-field id="input-equipo-nombre" v-model="equipoNombre" label="Nombre de este equipo" outlined
        hint="Por ejemplo «Caja de la entrada»." persistent-hint maxlength="120"></v-text-field>
    </div>

    <template #nota>
      <div class="instalar-aviso mt-4">
        <v-icon small color="success" class="me-2">mdi-lock-outline</v-icon>
        <span>La caja quedará amarrada a este equipo.</span>
      </div>
    </template>

    <template #acciones="{ invalid }">
      <v-btn block large color="success" elevation="0" @click="install" :loading="loading"
        :disabled="invalid || loading">
        {{ $t("install") }}
      </v-btn>
      <v-btn block text class="mt-2" @click="$store.dispatch('logoutAuth')">
        <v-icon small left>mdi-logout-variant</v-icon> {{ $t("logout") }}
      </v-btn>
    </template>
  </InstalarPantalla>
</template>
<script>
import InstalarPantalla from "@/components/base/InstalarPantalla.vue";
import { guardarHuellaDelCatalogo } from '@/plugins/pos/catalogo-al-dia';
import { aplicarExistencias } from '@/plugins/pos/existencias';
import bus from '@/plugins/bus-manager';
import localAgent from '@/plugins/local-agent.js'
import appUtil from "@/plugins/app-utils.js";
import { nombreDelEquipo, guardarNombreDelEquipo } from "@/plugins/pos-equipo.js";

export default {
  name: "Install",
  components: { InstalarPantalla },
  props: ["open"],
  data: () => ({
    dialog: true,
    key: 0,
    subsidiaries: [],
    cashResgisters: [],
    item: { bus_subsidiary_id: null, bill_cash_register_id: null },
    equipoNombre: nombreDelEquipo(),
    agent: false,
    backup: false,
    loading: false
  }),
  mounted() {
    this.loadSubsidiaries();
    this.validateAgent();

  },
  computed: {
    /** El instalador del agente vive junto a la API del entorno, no en localhost. */
    urlAgente() { return (process.env.VUE_APP_BASECONFIG_URL || '') + 'agente-impresion.exe'; },
  },
  methods: {
    changeLocationHref(){
      appUtil.changeLocationHref()
    },
    async restore() {
      this.loading = true
      let ok = await localAgent.restore(this.$db)

      setTimeout(() => {
        this.loading = false
        this.changeLocationHref();
      }, 5000)

    },
    async validateAgent() {

      try {
        let useAgent = false;
        let installation = this.$store.getters.installation;
        if (installation) {
          const cashRegister = await this.$db.getCashRegister(
            installation.cash_id
          );
          if(cashRegister){
            if(cashRegister.config){
              if(cashRegister.config.pos_active_print_agent){
                useAgent = true;
                console.log('use agent');
              }
            }
          }
        }	
        if(useAgent){
          // Realizar una solicitud GET a la API en localhost:5777/is-run
          const response = await localAgent.validateAgent();
          // Comprobar el código de estado de la respuesta (200 significa éxito)
          if (response.success == true) {
            this.agent = true; // La API está en funcionamiento
            if (response.backup) {
              this.backup = true
            }
            //this.validateBackup();
          } else {
            this.agent = false; // La API no está en funcionamiento
          }
        }
      } catch (e) {

      }

    },
    install() {
      this.$http
        .post(
          "api/v1/subsidiary/pos-install",
          { ...this.item, equipo_nombre: this.equipoNombre },
          true,
          true
        )
        .then(async (response) => {
          if (response.success) {
            guardarNombreDelEquipo(this.equipoNombre);
            await this.$db.install(response.config);
            // Caja nueva: la revisión al abrir empieza de cero; el inventario de su bodega ya llegó.
            guardarHuellaDelCatalogo(null);
            aplicarExistencias(this.$db, response.existencias);
            bus.$emit('ajustes-sin-conexion', response.sin_conexion);

            const inst = await this.$db.getInstallation();


            setTimeout(() => {
              let txt = this.$db.serialize();
              localAgent.save(txt)
            }, 500)

            this.$emit("installed");
          }
        });
    },
    changeSubsidiary(evt) {

      // param 'installed': false
      if (evt) {
        this.$http
          .get(
            "api/v1/cash-register",
            {
              subsidiary: [{ id: evt.id, }],
              _paginate: { page: 1, max_rows: 100 },
              _order: [{ field: "name", direction: "asc" }],
            },
            true,
            true
          )
          .then((response) => {
            if (response.success) {
              this.cashResgisters = response.items;
              //this.key++;
            }
          });
      } else {
        this.cashResgisters = [];
      }
    },

    loadSubsidiaries() {
      this.$http.get('api/v1/lists/subsidiary', { '_order': [{ field: "name", direction: "asc" }] })

        .then((response) => {
          if (response.success) {
            this.subsidiaries = response.items;
            this.key++;
          }
        });
    },
  },
};
</script>
